function Russia({ dimensions }) {
  const baseXml = `
  <svg width=${dimensions || 24} height=${dimensions || 24} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_521_1972)">
  <path d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z" fill="#F0F0F0"/>
  <path d="M31.0048 21.5659C31.648 19.8326 32 17.9579 32 16.0007C32 14.0436 31.648 12.1689 31.0048 10.4355H0.995188C0.352063 12.1689 0 14.0436 0 16.0007C0 17.9579 0.352063 19.8326 0.995188 21.5659L16 22.9572L31.0048 21.5659Z" fill="#0052B4"/>
  <path d="M16 31.9993C22.8795 31.9993 28.7442 27.6573 31.0049 21.5645H0.995239C3.25593 27.6573 9.12061 31.9993 16 31.9993Z" fill="#D80027"/>
  </g>
  </svg>
  `;

  return baseXml;
}

export default Russia;
